<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Settings'"
      [class]="extraClass"
      [canGoBack]="false" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="!windowService.isDesktopRes">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-text
            [title]="'Settings'" />
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="width: calc(100% + 60px); height: 100vh; margin-left: -20px" />
    }

    @if (loaded) {
      @if (integrations?.length) {
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/gold-link.svg'"
              class="title-size" />
            <tidy-text
              [header]="'Integration'" />
          </tidy-row>
          @for (integration of integrations; track integration) {
            <tidy-row>
              <tidy-text
                [body]="integration?.integration_data?.name + ' '" />
              <tidy-text
                class="link"
                [actionBody]="'Edit'"
                (action)="showMergeWidget()" />
            </tidy-row>
          }
        </tidy-card>
      }
      @if (!integrations?.length) {
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/gold-link.svg'"
              class="title-size" />
            <tidy-text
              [header]="'Integration'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="'No Integration Added '" />
            <tidy-text
              class="link"
              [actionBody]="'Add Integration'"
              (action)="showMergeWidget()" />
          </tidy-row>
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Connect your HR system and we will start syncing employees from this list. Talk to your success representative for help setting up campaigns. You will only be charged in accordance with your campaign settings.'" />
          </tidy-row>
        </tidy-card>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Please contact your account manager to change your account settings.'" />
      </tidy-row>
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
